import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Moon } from 'lucide-react';

const SunMoon = ({ weather, moonData }) => {
  return (
    <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur rounded-xl shadow-lg p-5 border border-orange-100 dark:border-gray-700 animate-on-scroll card-hover hover-lift">
      <h3 className="font-semibold text-lg mb-4 dark:text-gray-100">☀️ Sun & Moon</h3>
      
      {/* Today's sun times */}
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="bg-gradient-to-br from-orange-50 to-yellow-50 dark:from-orange-900/20 dark:to-yellow-900/20 p-4 rounded-lg">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">🌅 Sunrise</p>
          <p className="font-bold text-xl dark:text-gray-100">
            {(() => {
              if (!weather?.daily?.time || !weather?.daily?.sunrise) return '--';
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              const todayIndex = weather.daily.time.findIndex(dateStr => {
                const date = new Date(dateStr);
                date.setHours(0, 0, 0, 0);
                return date.getTime() === today.getTime();
              });
              return todayIndex >= 0 && weather.daily.sunrise[todayIndex] 
                ? new Date(weather.daily.sunrise[todayIndex]).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
                : '--';
            })()}
          </p>
        </div>
        <div className="bg-gradient-to-br from-pink-50 to-purple-50 dark:from-pink-900/20 dark:to-purple-900/20 p-4 rounded-lg">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">🌇 Sunset</p>
          <p className="font-bold text-xl dark:text-gray-100">
            {(() => {
              if (!weather?.daily?.time || !weather?.daily?.sunset) return '--';
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              const todayIndex = weather.daily.time.findIndex(dateStr => {
                const date = new Date(dateStr);
                date.setHours(0, 0, 0, 0);
                return date.getTime() === today.getTime();
              });
              return todayIndex >= 0 && weather.daily.sunset[todayIndex] 
                ? new Date(weather.daily.sunset[todayIndex]).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
                : '--';
            })()}
          </p>
        </div>
      </div>
      
      {/* Current moon phase */}
      {moonData?.current && (
        <div className="p-4 bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="text-3xl">{moonData.current.emoji}</span>
              <div>
                <p className="font-semibold dark:text-gray-100">{moonData.current.name}</p>
                <p className="text-sm text-gray-600 dark:text-gray-400">{moonData.current.illumination}% illuminated</p>
              </div>
            </div>
            <div className="text-right text-sm">
              <p className="text-gray-600 dark:text-gray-400">🌙 Rise: <span className="font-medium dark:text-gray-200">{moonData.current.moonrise}</span></p>
              <p className="text-gray-600 dark:text-gray-400">🌘 Set: <span className="font-medium dark:text-gray-200">{moonData.current.moonset}</span></p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

SunMoon.propTypes = {
  weather: PropTypes.shape({
    daily: PropTypes.shape({
      time: PropTypes.arrayOf(PropTypes.string),
      sunrise: PropTypes.arrayOf(PropTypes.string),
      sunset: PropTypes.arrayOf(PropTypes.string)
    })
  }),
  moonData: PropTypes.shape({
    current: PropTypes.shape({
      emoji: PropTypes.string,
      name: PropTypes.string,
      illumination: PropTypes.number,
      moonrise: PropTypes.string,
      moonset: PropTypes.string
    })
  })
};

export default memo(SunMoon);